import { createApi } from "@reduxjs/toolkit/query/react";
import { IClause } from "../../interfaces";
import { axiosBaseQuery } from "../axiosConfig";
import { RequestMethod } from "../enum";
import { suggestionApi } from "../suggestion";
import { ToggleFavoriteRequest } from "./types";

const setClauseFavoriteQuery = ({ workspaceId, id, ...args }: ToggleFavoriteRequest) => ({
  url: `/${id}`,
  method: RequestMethod.PATCH,
  data: args,
  workspaceId,
});

export const favoritesApi = createApi({
  reducerPath: "favorites",
  baseQuery: axiosBaseQuery<any>({
    baseUrl: "/clauses",
  }),
  endpoints: (build) => ({
    fetchUserFavorites: build.query<string[], void>({
      queryFn: async (args) => {
        return { data: [] };
      },
    }),
    setClauseFavorite: build.mutation<void, ToggleFavoriteRequest>({
      query: setClauseFavoriteQuery,
      onQueryStarted: async (args, { dispatch, queryFulfilled, getState }) => {
        const optimisticUpdate = dispatch(
          favoritesApi.util.updateQueryData("fetchUserFavorites", undefined, (savedData) => {
            savedData.push(args.id);
          })
        );
        try {
          await queryFulfilled;
          const state: any = getState();
          const suggestionSearches = suggestionApi.util.selectCachedArgsForQuery(state, "searchSuggestions");

          suggestionSearches.forEach((searchArgs) => {
            dispatch(
              suggestionApi.util.updateQueryData("searchSuggestions", searchArgs, (data: IClause[]) => {
                const index = data.findIndex((cl) => cl.clause_id === args.id);
                if (index > -1) data[index] = { ...data[index], is_favorite: args.isFavorite };
                return data;
              })
            );
          });
        } catch (err) {
          console.error(err);
          optimisticUpdate.undo();
        }
      },
    }),
  }),
});
